import Decimal from 'decimal.js';
import { getEodRate, getRate } from '.';
import { BUY_SELL_MAIN, FX } from '../constants';

export const findSwapReinvestmentUserSetting = ({ instrumentId, side, userSettings, isLoadingUserSettings } = {}) => {
  if (isLoadingUserSettings || !userSettings?.length) {
    return null;
  }
  return userSettings.find((item) => item.instrumentId === instrumentId && item.side === side) || null;
};

export const findSwapReinvestmentAdminSetting = ({ instrumentId, side: _side, instrumentList } = {}) => {
  const { swapReinvestment } = instrumentList?.[instrumentId] ?? {};
  if (!swapReinvestment) {
    return null;
  }
  return swapReinvestment; // swapReinvestment[side]; // TODO 確認
};

export const getSwapReinvestmentDefaultRateLimit = ({ instrumentId, side, rates, accountInfo } = {}) => {
  const serviceId = FX;
  if (!instrumentId) {
    return null;
  }
  const rate = getRate(serviceId, rates, instrumentId, accountInfo);
  const eodRate = getEodRate(rate);
  if (!eodRate) {
    return null;
  }
  const { ask, bid } = eodRate;
  /*
   * レート設定→上限：前日終値×1.5
   *   下限：前日終値×0.5
   *   初期値：前日終値
   */

  const eod = side === BUY_SELL_MAIN.BUY.ID ? ask : bid;
  const defaultRateLimit = eod;
  const minRateLimit = Decimal.mul(eod, 0.5);
  const maxRateLimit = Decimal.mul(eod, 1.5);
  return {
    defaultRateLimit,
    minRateLimit,
    maxRateLimit,
  };
};

export const getSwapReinvestmentDefaultQuantityLimit = ({ instrumentId: _instanceId, side: _side } = {}) => {
  const defaultQuantityLimit = new Decimal(10); // TODO
  const minQuantityLimit = new Decimal(0.1); // TODO
  const maxQuantityLimit = new Decimal(100); // TODO
  return {
    defaultQuantityLimit,
    minQuantityLimit,
    maxQuantityLimit,
  };
};
